import React from "react";
import { Offcanvas } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import moment from "moment";
import { commonService } from "../../../utils/commonService";
import Loader from "../../Loader/Loader";

const MorningBriefingDateDetailModal = ({
  showDetail,
  setShowDetail,
  selectedDateData,
  rateShopData,
  bookingPaceData,
  marketSegmentMixData,
  isLoadingRateShop,
  isLoadingBookingPace,
  isLoadingMarketSegmentMix,
}) => {
  return (
    <Offcanvas
      show={showDetail}
      onHide={() => setShowDetail(false)}
      placement="end"
      className="mb-detail-offcanvas"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>MORNING BRIEFING → DATE DETAIL</Offcanvas.Title>
      </Offcanvas.Header>
      {selectedDateData && (
        <Offcanvas.Body className="p-0">
          <div className="mb-detail-header">
            <h3 className="mb-detail-title">
              {moment(selectedDateData.date).format("ddd M/D")} ·{" "}
              {selectedDateData.eventName || "Event"}
            </h3>
          </div>

          <div className="mb-stat-grid">
            <div className="mb-stat-card">
              <div className="mb-stat-value">
                {commonService?.formateRoom(selectedDateData.otbOcc)}
              </div>
              <div className="mb-stat-label">OTB</div>
            </div>
            <div className="mb-stat-card">
              <div className="mb-stat-value">
                {commonService?.formateRoom(selectedDateData.novaForecast)}
              </div>
              {/* <div className="mb-stat-label">NOVE FORECAST</div> */}
              <div className="mb-stat-label">SYSTEM FORECAST</div>
            </div>
            <div className="mb-stat-card">
              {/* <div className="mb-stat-value">{selectedDateData.stlyPace}%</div> */}
              <div className="mb-stat-value">
                {commonService?.formateRoom(selectedDateData.stlyPace)}
              </div>
              {/* <div className="mb-stat-label">STLY PACE</div> */}
              <div className="mb-stat-label">STLY</div>
            </div>
            <div className="mb-stat-card">
              <div className="mb-stat-value">
                {selectedDateData.demandScore}/100
              </div>
              <div className="mb-stat-label">DEMAND SCORE</div>
            </div>
            <div className="mb-stat-card">
              <div className="mb-stat-value">
                {commonService?.formateAmount(selectedDateData.myBar)}
              </div>
              <div className="mb-stat-label">MY BAR</div>
            </div>
            <div className="mb-stat-card">
              <div className="mb-stat-value">
                {commonService?.formateAmount(selectedDateData.compSetAvg)}
              </div>
              <div className="mb-stat-label">COMP SET AVG</div>
            </div>
          </div>

          <div className="mb-section mb-2">
            <div className="mb-section-title">
              PACE CURVE — OTB BUILD BY DAYS BEFORE ARRIVAL
            </div>
            <div className="mb-pace-chart">
              {isLoadingBookingPace ? (
                <div
                  style={{
                    padding: "10px 0",
                    minHeight: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Loader />
                </div>
              ) : (
                <>
                  <Line
                    data={{
                      labels: bookingPaceData
                        ? bookingPaceData.labels
                        : ["60d", "50d", "40d", "30d", "20d", "10d"],
                      datasets: [
                        {
                          data: bookingPaceData
                            ? bookingPaceData.RMS
                            : [0, 10, 20, 30, 40, selectedDateData.otbOcc],
                          borderColor: "#d29922",
                          borderWidth: 2,
                          pointRadius: bookingPaceData ? 0 : 2,
                          tension: 0.1,
                        },
                        {
                          data: bookingPaceData
                            ? bookingPaceData.STLYRMS
                            : [0, 5, 12, 22, 30, selectedDateData.stlyPace],
                          borderColor: "#8b949e",
                          borderWidth: 1,
                          borderDash: [5, 5],
                          pointRadius: bookingPaceData ? 0 : 2,
                          tension: 0.1,
                        },
                      ],
                    }}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      plugins: { legend: { display: false } },
                      scales: {
                        x: {
                          grid: { display: false },
                          ticks: {
                            color: "#57606a",
                            font: { size: 10 },
                            callback: function (val, index) {
                              const label = this.getLabelForValue(val);
                              if (
                                [
                                  "0",
                                  "0d",
                                  "30",
                                  "30d",
                                  "60",
                                  "60d",
                                  "90",
                                  "90d",
                                ].includes(label)
                              ) {
                                return label === "0" ? "0d" : label;
                              }
                              return "";
                            },
                          },
                        },
                        y: {
                          grid: { color: "#d0d7de" },
                          ticks: {
                            color: "#57606a",
                            stepSize: 33,
                            callback: (v) => v + "%",
                          },
                        },
                      },
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "15px",
                      fontSize: "0.75rem",
                      marginTop: "5px",
                    }}
                  >
                    <span style={{ color: "#d29922" }}>— This year</span>
                    <span style={{ color: "#8b949e" }}>-- STLY</span>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="mb-section">
            <div className="mb-section-title">
              COMP SET — SHOPPED RATES FOR THIS DATE
            </div>
            {isLoadingRateShop ? (
              <div
                style={{
                  padding: "10px 0",
                  minHeight: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Loader />
              </div>
            ) : (
              <table className="mb-table">
                <thead>
                  <tr>
                    <th>PROPERTY</th>
                    <th>RATE</th>
                    <th>VARIANCE</th>
                    {/* <th>VS MY BAR</th> */}
                  </tr>
                </thead>
                <tbody>
                  {rateShopData && rateShopData.length > 0 ? (
                    [...rateShopData]
                      .sort((a, b) => {
                        if (a.IsSelf) return -1;
                        if (b.IsSelf) return 1;
                        const rateA = parseFloat(a.Rate || a.rate || 0);
                        const rateB = parseFloat(b.Rate || b.rate || 0);
                        const diffA = rateA - selectedDateData.myBar;
                        const diffB = rateB - selectedDateData.myBar;
                        return diffA - diffB;
                      })
                      .map((item, index) => {
                        const isYou = item.IsSelf;
                        const propertyName = isYou
                          ? `${item.competiterpropertyname} (self)`
                          : item.competiterpropertyname;
                        const rate = parseFloat(item.Rate || item.rate || 0);
                        let vsMyBarStr = "";
                        let vsMyBarClass = "";
                        let customStyle = {};

                        if (!isYou) {
                          const diff = rate - selectedDateData.myBar;
                          vsMyBarStr = `${commonService?.formateAmount(diff)}`;

                          if (diff > 0) {
                            customStyle = { color: "green" };
                          } else if (diff < 0) {
                            customStyle = { color: "red" };
                          }
                        }

                        return (
                          <tr key={index}>
                            <td className="text-start" title={propertyName}>
                              {commonService?.truncateName(propertyName, 40)}
                            </td>
                            <td>{commonService?.formateAmount(rate)}</td>
                            <td className={vsMyBarClass} style={customStyle}>
                              {vsMyBarStr}
                            </td>
                          </tr>
                        );
                      })
                  ) : (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center" }}>
                        No rate shop data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* Temp Commented */}
          {/* <div className="mb-section">
            <div className="mb-section-title">
              DEMAND SCORE BREAKDOWN — WEIGHTED SIGNALS
            </div>
            <div className="mb-progress-row">
              <div className="mb-progress-label">Booking pace vs STLY</div>
              <div className="mb-progress-bar-container">
                <div
                  className="mb-progress-bar"
                  style={{ width: "98%", backgroundColor: "#238636" }}
                ></div>
              </div>
              <div className="mb-progress-value">98</div>
            </div>
            <div className="mb-progress-row">
              <div className="mb-progress-label">Market compression</div>
              <div className="mb-progress-bar-container">
                <div
                  className="mb-progress-bar"
                  style={{ width: "64%", backgroundColor: "#d29922" }}
                ></div>
              </div>
              <div className="mb-progress-value">64</div>
            </div>
            <div className="mb-progress-row">
              <div className="mb-progress-label">Event impact</div>
              <div className="mb-progress-bar-container">
                <div
                  className="mb-progress-bar"
                  style={{ width: "98%", backgroundColor: "#238636" }}
                ></div>
              </div>
              <div className="mb-progress-value">98</div>
            </div>
            <div className="mb-progress-row">
              <div className="mb-progress-label">Cancellation adjustment</div>
              <div className="mb-progress-bar-container">
                <div
                  className="mb-progress-bar"
                  style={{ width: "28%", backgroundColor: "#8b949e" }}
                ></div>
              </div>
              <div className="mb-progress-value">28</div>
            </div>
          </div> */}

          <div className="mb-section">
            <div className="mb-section-title">
              SEGMENT MIX — OTB FOR THIS DATE
            </div>
            {isLoadingMarketSegmentMix ? (
              <div
                style={{
                  padding: "10px 0",
                  minHeight: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Loader />
              </div>
            ) : marketSegmentMixData && marketSegmentMixData?.length > 0 ? (
              marketSegmentMixData.map((item, index) => {
                const rawPct = item?.["Rooms Sold Pct"] ?? 0;
                const pct =
                  typeof rawPct === "number" ? Math.round(rawPct) : rawPct;

                return (
                  <div className="mb-progress-row" key={index}>
                    <div className="mb-progress-label">
                      {item.MarketSegment ?? "N/A"}
                    </div>

                    <div
                      className="mb-progress-bar-container"
                      style={{ backgroundColor: "#f6f8fa" }}
                    >
                      <div
                        className="mb-progress-bar"
                        style={{
                          width: `${pct}%`,
                          backgroundColor: "#8a2be2",
                        }}
                      />
                    </div>

                    <div className="mb-progress-value">{pct}%</div>
                  </div>
                );
              })
            ) : (
              <div
                className="text-center text-muted py-4"
                style={{ minHeight: "150px" }}
              >
                No data available.
              </div>
            )}
          </div>

          <div className="mb-footer-alert">
            <span>Rate IQ — {selectedDateData.rateIq || "underpriced"}.</span>{" "}
            {selectedDateData.flagText
              ? selectedDateData.flagText
              : "Pace is +19pts vs STLY with BAR unchanged 14 days and comp avg $11 above you. Pricing Ladder suggests $155–$159."}{" "}
            Recommended — you decide.
          </div>
        </Offcanvas.Body>
      )}
    </Offcanvas>
  );
};

export default MorningBriefingDateDetailModal;
